import {
  ContainerSingleMode,
  OuterContainerBuffon,
  FiltersContainerBuffon,
  SelectWrapper,
} from '../headerWithFilters.style';

import { StableSelect } from '../../../../../components/SharedComponents/sharedComponents.index';
import { CustomHeading } from '../../../../../components/StyledComponents/styleComponents.index';

import PropTypes from "prop-types";
import { COMPANY_STORE_ID } from '../../../../../components/components.constants';
import { useState } from 'react';

export const SingleModeFilter = ({ actions, ctx, uiState }) => {
  
    const { setCurrentStoreData } = actions || {};
    
    const { 
        labels,
        // data,
        // currentStoreId,
        // valueKey,
        // labelKey,
        // labelPrefix,
        // companyValue,
        // companyLabel
    } = ctx || {};

    const { headerContainerStyle = {}, containerStyle = {} } = uiState || {};

    //const [localStoreValue, setLocalStoreValue] = useState(companyValue);

    //const isCompanyStoreId = currentStoreId === COMPANY_STORE_ID.STORE_ID;

    // const buildStoreOptions = ({items, valueKey, labelKey, companyValue, companyLabel, labelPrefix}) =>
    //     items?.map(item => {
    //         const value = item?.[valueKey];
    //         const label =
    //         value === companyValue ? companyLabel : `${labelPrefix} ${item?.[labelKey] ?? value}`;

    //     return { value, label };
    // }) || [];

    // const options = buildStoreOptions({
    //     items: data,
    //     valueKey: valueKey,
    //     labelKey: labelKey,
    //     companyValue: companyValue,
    //     labelPrefix: labelPrefix,
    //     companyLabel: companyLabel
    // });

    // const handleStoreChange = (selectedValue) => {
    //   const storeData = data?.find(item => item?.[valueKey] === selectedValue);
    
    //   if (storeData) {
    //     const storeValueToSet = storeData[valueKey];
    //     setCurrentStoreData(storeValueToSet);
    //     setLocalStoreValue(storeValueToSet);
    //   }
    // };

    const defaultHeaderStyle = { 
        display: 'flex', 
        flexDirection: 'column', 
        gap: '0rem' 
    };

    const defaultContainerStyle = {
        display: 'grid',
        blockSize: '100%',
        inlineSize: '100%',
        gridTemplateColumns: '1fr 1fr'
    }

    return (
        <section style={{ ...defaultContainerStyle, ...containerStyle }}>
            <div style={{ ...defaultHeaderStyle, ...headerContainerStyle }}>
                <p style={{ margin: 0, fontSize: "1rem", fontWeight: 700, color: "#111827" }}>
                    {labels.titlePage}
                </p>
                <div style={{ display: "flex", alignItems: "baseline", gap: "4px" }}>
                    <span style={{ fontSize: "0.8rem", fontWeight: 600, color: "#374151" }}>
                    {labels.family}
                    </span>
                    <span style={{ fontSize: "0.8rem", color: "#a8b0bb" }}>
                    {labels.familyName}
                    </span>
                </div>
            </div>

            {/* {isCompanyStoreId && (
                <OuterContainerBuffon>
                    <FiltersContainerBuffon>
                    <SelectWrapper 
                        style={{ 
                        display: "flex", 
                        flexDirection: "row", 
                        alignItems: "center", 
                        gap: "0.5rem", 
                        gridArea: "lojas", 
                        justifyContent: "end" 
                        }}
                    >
                        <div style={{ display: "inline-block", width: "100%" }}>
                        <StableSelect
                            label=""
                            options={options}
                            value={localStoreValue}
                            onChange={handleStoreChange}
                            width=""
                        />
                        </div>
                    </SelectWrapper>
                    </FiltersContainerBuffon>
                </OuterContainerBuffon>
            )} */}
        </section>
    );
};

SingleModeFilter.propTypes = { 
    actions: PropTypes.shape(), 
    ctx: PropTypes.shape(), 
}